<script lang="ts">
    import { onMount, onDestroy } from 'svelte';

    onMount(async () => {
        window.addEventListener('scroll', moveBallsHome);
	});
    onDestroy(() => {
        window.removeEventListener('scroll', moveBallsHome, false);
    })

    function moveBallsHome (){
        let moveUp = "translateY(" + -1*(window.scrollY/4) + "px)";
        let moveDown = "translateY(" + 1*(window.scrollY/4) + "px)";
        const ball1 = document.getElementById("idBall1");
        const ball2 = document.getElementById("idBall2");
        const ball3 = document.getElementById("idBall3");
        const ball4 = document.getElementById("idBall4");
        const ball5 = document.getElementById("idBall5");
        const ball6 = document.getElementById("idBall6");
        ball1.style.transform=moveUp;
        ball2.style.transform=moveDown;
        ball3.style.transform=moveUp;
        ball4.style.transform=moveDown;
        ball5.style.transform=moveUp;
        ball6.style.transform=moveUp;
    }

</script>
    
<style lang="scss">
    
    .ball {
        position: absolute;
        border-radius: 50%;
        mix-blend-mode: multiply;
        &__3 {
            top: 400px;
            left: 50px;
            width: 30px;
            height: 30px;
            background-color: $color_primary;    
        }
        &__1 {
            top: 250px;
            left: 50px;
            width: 50px;
            height: 50px;
            background-color: $color_secondary;    
        }
        &__2 {
            top: 650px;
            left: 35px;
            width: 30px;
            height: 30px;
            background-color: $color_secondary;    
        }
        &__4 {
            top: 400px;
            right: 40px;
            width: 20px;
            height: 20px;
            background-color: $color_primary;    
        }
        &__5 {
            top: 180px;
            right: 100px;
            width: 50px;
            height: 50px;
            background-color: $color_secondary;    
        }
        &__6 {
            top: 600px;
            right: 20px;
            width: 60px;
            height: 60px;
            background-color: $color_primary;    
        }
    }

    @include large {
        .ball {
            position: absolute;
            border-radius: 50%;
            mix-blend-mode: multiply;
            &__1 {
                top: 500px;
                left: 50px;
                width: 50px;
                height: 50px;
                background-color: $color_primary;    
            }
            &__2 {
                top: 250px;
                left: 250px;
                width: 100px;
                height: 100px;
                background-color: $color_secondary;    
            }
            &__3 {
                top: 650px;
                left: 350px;
                width: 30px;
                height: 30px;
                background-color: $color_secondary;    
            }
            &__4 {
                top: 180px;
                right: 500px;
                width: 120px;
                height: 120px;
                background-color: $color_primary;    
            }
            &__5 {
                top: 280px;
                right: 200px;
                width: 50px;
                height: 50px;
                background-color: $color_secondary;    
            }
            &__6 {
                top: 600px;
                right: 20px;
                width: 80px;
                height: 80px;
                background-color: $color_primary;    
            }
        }
    }

</style>

<div id="idBall1" class="ball ball__1"></div>
<div id="idBall2" class="ball ball__2"></div>
<div id="idBall3" class="ball ball__3"></div>
<div id="idBall4" class="ball ball__4"></div>
<div id="idBall5" class="ball ball__5"></div>
<div id="idBall6" class="ball ball__6"></div>